module.exports = __webpack_public_path__ + "img/exclamation-mark.dd9da1c0.svg";